import { call, put, takeLatest, select, delay } from 'redux-saga/effects';

import { getCognitoId, getDeltaId } from '../libs/auth';
import {
  createStudentApplication,
  fetchStudentApplication,
  updateStudentApplication,
  deleteStudentApplication,
  updateStudentApplicationStatus
} from '../libs/apiCalls';
import { addAlert, toggleSubmitted } from '../actions'
import * as actions from '../actions/types';
import { debugLog } from "../libs/utilities";

export const getUser = (state) => state.auth.user;
const isApplicationSet = (state) => state.appInfo.applicationSet;
const getCurrentAppId = (state) => state.appInfo.application.periodId;

function pause(delay) {
  return new Promise(resolve => {
    setTimeout(() => {
      resolve()
    }, delay.millis)
  });
}

const alertTimeoutDefault = 2000;

function* createApplication(action) {
  let user = yield select(getUser);
  if(user) {
    try {
      const result = yield call(createStudentApplication, yield getDeltaId(), action.application);
      debugLog('createApplication result: ', result);
      if(result.status) {
        yield put({type: actions.CREATE_APPLICATION_SUCCESS, application: result.application});
        yield put({type: actions.SET_APPLICATION, application: result.application});
        const alertAction = yield put(addAlert('success', 'Application Created'));
        yield call(pause, { millis: alertTimeoutDefault});
        yield put({type: actions.REMOVE_ALERT, id: alertAction.alert.id});
      } else {
        yield put({type: actions.CREATE_APPLICATION_FAILURE});
        yield put(addAlert('danger', 'Unable to create application: ' + result.reason));
      }
    } catch (e) {
      yield put({type: actions.CREATE_APPLICATION_FAILURE});
      yield put(addAlert('danger', 'Uncaught Error: ' + e.message));
    }
  }
}

function* fetchApplication(action) {
  // Make sure we don't already have this application
  let appSet = yield select(isApplicationSet);
  let currentAppId = yield select(getCurrentAppId);
  if(appSet && currentAppId === action.applicationId)
    yield put({type: actions.APP_ALREADY_SET});
  else {
    try {
      const result = yield call(fetchStudentApplication, yield getDeltaId(), action.applicationId);
      if (result.status) {
        const application = result.application;
        yield put({ type: actions.FETCH_APPLICATION_SUCCESS });
        yield put({ type: actions.SET_APPLICATION, application });
      } else {
        yield put({ type: actions.FETCH_APPLICATION_FAILURE });
        yield put(addAlert('danger', 'Unable to fetch Application: ' + result.reason));
      }
    } catch (e) {
      yield put(addAlert('danger', 'Uncaught Error: ' + e.message));
    }
  }
}

function* updateApplication(action) {
  let user = yield select(getUser);
  let currentAppId = yield select(getCurrentAppId);
  if(user) {
    try {
      const result = yield call(updateStudentApplication, yield getDeltaId(), currentAppId, action.updates);
      if (result.status) {
        yield put({type: actions.UPDATE_APPLICATION_SUCCESS});
        yield put({type: actions.REFRESH_APPLICATION, application: result.application});
        const alertAction = yield put(addAlert('success', 'Application Saved'));
        //yield call(pause, { millis: alertTimeoutDefault});
        yield delay(2000);
        yield put({type: actions.REMOVE_ALERT, id: alertAction.alert.id});
      } else {
        yield put({type: actions.UPDATE_APPLICATION_FAILURE});
        yield put(addAlert('danger', 'Unable to update application: ' + result.reason));
      }
    } catch (e) {
      yield put({type: actions.UPDATE_APPLICATION_FAILURE});
      yield put(addAlert('danger', 'Uncaught Error: ' + e.message));
    }
  }
}

function* updateApplicationStatus(action) {
  let user = yield select(getUser);
  let currentAppId = yield select(getCurrentAppId);
  if(user) {
    try {
      const result = yield call(updateStudentApplicationStatus, yield getDeltaId(), currentAppId, action.status);
      if (result.status) {
        yield put({type: actions.UPDATE_APPLICATION_STATUS_SUCCESS});
        yield put({type: actions.REFRESH_APPLICATION, application: result.application});
        const alertAction = yield put(addAlert('success', 'Application Status Updated'));
        //yield call(pause, { millis: alertTimeoutDefault});
        yield delay(2000);
        yield put({type: actions.REMOVE_ALERT, id: alertAction.alert.id});
      } else {
        yield put({type: actions.UPDATE_APPLICATION_STATUS_FAILURE});
        yield put(addAlert('danger', 'Unable to update application: ' + result.reason));
      }
    } catch (e) {
      yield put({type: actions.UPDATE_APPLICATION_STATUS_FAILURE});
      yield put(addAlert('danger', 'Uncaught Error: ' + e.message));
    }
  }
}

function* submitApplication(action) {
  let user = yield select(getUser);
  let currentAppId = yield select(getCurrentAppId);
  if(user) {
    try {
      const result = yield call(updateStudentApplication, yield getDeltaId(), currentAppId, action.application);
      if(result.status) {
        yield put({type: actions.SUBMIT_APPLICATION_SUCCESS, application: result.application});
        yield put({type: actions.SET_APPLICATION, application: result.application});
        yield put(addAlert('success', 'Application Submitted Successfully'));
        yield put(toggleSubmitted());
      } else {
        yield put({type: actions.SUBMIT_APPLICATION_FAILURE});
        yield put(addAlert('danger', 'Unable to submit application: ' + result.reason))
      }
    } catch (e) {
      debugLog('submitApplication error: ', e.message);
      yield put({type: actions.SUBMIT_APPLICATION_FAILURE});
      yield put(addAlert('danger', 'Uncaught Error: ' + e.message));
    }
  }
}

function* deleteApplication(action) {
  let user = yield select(getUser);
  if(user) {
    try {
      const result = yield call(deleteStudentApplication, yield getDeltaId(), action.applicationId);
      if (result.status) {
        yield put({type: actions.DELETE_APPLICATION_SUCCESS, applicationId: action.applicationId});
        yield put({type: actions.SET_USER, user: result.user});
        yield put(addAlert('success', 'Application Deleted'));
      } else {
        yield put({type: actions.DELETE_APPLICATION_FAILURE});
        yield put(addAlert('danger', 'Unable to delete application'));
      }
    } catch (e) {
      yield put(addAlert('danger', 'Uncaught Error: ' + e.message));
    }
  }
}

function* mySaga() {
  yield takeLatest(actions.CREATE_APPLICATION_REQUEST, createApplication);
  //yield takeLatest(actions.FETCH_APPLICATION_REQUEST, fetchApplication);
  yield takeLatest(actions.UPDATE_APPLICATION_REQUEST, updateApplication);
  yield takeLatest(actions.UPDATE_APPLICATION_STATUS_REQUEST, updateApplicationStatus);
  yield takeLatest(actions.DELETE_APPLICATION_REQUEST, deleteApplication);
  yield takeLatest(actions.SUBMIT_APPLICATION_REQUEST, submitApplication);
}

export default mySaga;